import { useQuery } from '@tanstack/react-query';

async function parseInstanceData(instanceData) {
	const countries = new Set();
	const venues = new Set();
	const status = new Set();

	instanceData.forEach((month) => {
		if (month.instances && month.instances.length === 0) {
			return;
		}

		month.instances.forEach((instance) => {
			if (instance.country) {
				countries.add(instance.country.trim());
			}

			if (instance.venue) {
				venues.add(instance.venue.trim());
			}

			if (instance.status) {
				status.add(instance.status.trim());
			}
		});
	});

	return { countries, venues, status };
}

/**
 * Fetch recipes with pagination and search
 * @returns {object}
 */
function useFilters({ instanceData }) {
	const { isPending, isError, data, error } = useQuery({
		queryKey: ['filters'],
		queryFn: async () => {
			const categories = new Set();

			const categoriesResponse = await fetch(
				'https://us-central1-euneos-cms-prod.cloudfunctions.net/api/categories'
			);

			const categoriesJson = await categoriesResponse.json();

			categoriesJson.forEach((category) => {
				if (category.name.en) {
					categories.add({
						uid: category.uid,
						name: category.name.en,
					});
				}
			});

			const { countries, venues, status } =
				await parseInstanceData(instanceData);

			return {
				categories: Array.from(categories),
				countries: Array.from(countries),
				venues: Array.from(venues),
				status: Array.from(status),
			};
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
	};
}

export { useFilters };
